import AOS from 'aos';
import '../../stylesheets/plugin/aos/aos.scss';

/**
 * Component animation
 * add attribute to component data-aos="animation_name"
 */
export default class Animations {
  constructor() {
    setTimeout(() => {
      AOS.init({});
    }, 10);
  }
}
